import {NgModule} from '@angular/core';

import {PivotPointsPopupComponent} from './pivot-points-popup.component';
import {CommonModule} from "@angular/common";
import {DevExtremeModule} from "../devextreme.module";
import {TrendIconComponent} from "./trend-icon.component";

@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule
    ],
    exports: [
        PivotPointsPopupComponent
    ],
    declarations: [
        PivotPointsPopupComponent,
        TrendIconComponent
    ],
    providers: [],
})
export class PivotPointsPopupModule {
}
